export default __webpack_public_path__ + "static/media/aflac-sponsor-logo.beebcbe2.png";